export enum TeamViewMode {
    ALL,
    MY_TEAMS,
}
